
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deckbuilder",
      function () {
        return require("private-next-pages/deckbuilder.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deckbuilder"])
      });
    }
  